import React from "react";
import { HeroSection } from "./galaxy-interactive-hero-section";

export function HeroSectionBasic() {
  return (
    <main className="bg-black relative h-screen w-screen">
      <HeroSection />
    </main>
  );
}
